var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPause({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.647-1c.513 0 .936.386.993.883l.007.117v16c0 .552-.448 1-1 1-.513 0-.935-.386-.993-.883L10.647 16V0c0-.552.448-1 1-1zm-10 0c.513 0 .936.386.993.883L2.647 0v16c0 .552-.448 1-1 1-.513 0-.935-.386-.993-.883L.647 16V0c0-.552.448-1 1-1z",
    transform: "translate(-1255 -592) translate(462 10) translate(0 95) translate(0 61) translate(47.5 32) translate(384.5 383) translate(348) translate(13.353 12)"
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.2e2678c1af0b7c8c9952c61633a93f23.svg";
export { ForwardRef as ReactComponent };